export interface PackageMappingRow {
  package_location_id: string;
  package_id: string;
  package_name: string;
  type?: string | null;
  wash_types?: string[];
  way_package_id?: string | null;
}

export interface PackageMappingListFilters {
  type?: string;
  wash_types?: string[];
}

export interface PackageMappingUpdateItem {
  package_id: string;
  way_package_id: string | null;
}

export interface PackageMappingsPayload {
  mappings: PackageMappingUpdateItem[];
}

/** Editable row for Way ↔ SaaS package mapping. */
export interface PackageMappingFormRow {
  package_location_id: string;
  package_id: string;
  package_name: string;
  type: string | null;
  wash_types: string[];
  way_package_id: string;
  saved_way_package_id: string;
  fieldError: string;
}

export const MAX_WAY_PACKAGE_ID_LENGTH = 100;
